import { getPhoneNumber } from 'helpers/common'
import { BranchForForm, BranchForApiSubmit } from 'types'
import { IBranchSingleProps, IBranchSinglePropsForList } from './model'
import { ITicketSelectBranchList } from 'features/Ticket/TicketSelectBranch'
import { getPhoneFormatter } from 'helpers/common'

export const formatList = (
  branches: IBranchSingleProps[],
): IBranchSinglePropsForList[] => {
  const nextBranches = branches.map((branch) => ({
    ...branch,
    phone: getPhoneFormatter(getPhoneNumber(branch.contacts)),
    isActive: Boolean(branch.isActive),
  }))

  return nextBranches
}

export const formatTicketBranchList = (
  branches: IBranchSingleProps[],
): ITicketSelectBranchList[] => {
  const nextBranches: ITicketSelectBranchList[] = branches.map((branch) => {
    return {
      no: branch.no,
      id: branch.id,
      branchName: branch.name,
      companyId: branch.companyId,
      companyName: branch.companyName,
      phone: getPhoneFormatter(getPhoneNumber(branch.contacts)),
      branchAddress: branch.addresses,
      branchAreaEn: branch.addresses[0]?.provinceEn,
      branchAreaTh: branch.addresses[0]?.provinceTh,
      branchContactName: branch.contactName,
      isActive: Boolean(branch.isActive),
    }
  })

  return nextBranches
}

export const formatForm = (payload: BranchForForm): BranchForApiSubmit => {
  const processingPayload: Partial<BranchForForm> & BranchForApiSubmit = {
    ...payload,
    countryTh: payload.country['countryTh'],
    countryEn: payload.country['countryEn'],
    provinceTh: payload.province['provinceTh'],
    provinceEn: payload.province['provinceEn'],
    districtTh: payload.district['districtTh'],
    districtEn: payload.district['districtEn'],
    subDistrictTh: payload.subDistrict['subDistrictTh'],
    subDistrictEn: payload.subDistrict['subDistrictEn'],
  }

  delete processingPayload.currentState

  delete processingPayload.country
  delete processingPayload.province
  delete processingPayload.district
  delete processingPayload.subDistrict

  if (!processingPayload.phoneNumber) {
    delete processingPayload.countryCode
    delete processingPayload.phoneNumber
  }

  const nextPayload: BranchForApiSubmit = processingPayload

  const params = {
    ...nextPayload,
    name: nextPayload.name.trim(),
    location: nextPayload.location.trim(),
    detail: nextPayload.detail?.trim(),
    contactName: nextPayload.contactName.trim(),
  }

  return params
}
